import { FilterActionTypes, UrlActionTypes } from '../../../enums/ActionEnums';
export const filterActions = {
    updateFilters: (payload) => ({
        type: UrlActionTypes.UPDATE_FILTERS,
        payload,
    }),
    setFilterObject: (payload) => ({
        type: FilterActionTypes.SET_FILTERS,
        payload,
    }),
    removeFilterObject: (payload) => ({
        type: FilterActionTypes.REMOVE_FILTER,
        payload,
    }),
    removeAllFilters: () => ({
        type: FilterActionTypes.REMOVE_ALL_FILTERS,
    }),
    setActiveFilters: (payload) => ({
        type: FilterActionTypes.SET_ACTIVE_FILTERS,
        payload,
    }),
};
